import { render, staticRenderFns } from "./DPHZ.vue?vue&type=template&id=070a34a4&scoped=true"
import script from "./DPHZ.vue?vue&type=script&lang=js"
export * from "./DPHZ.vue?vue&type=script&lang=js"
import style0 from "./DPHZ.vue?vue&type=style&index=0&id=070a34a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070a34a4",
  null
  
)

export default component.exports